import React from "react";
import { Box } from "@mui/material";
import logo from "../../../assets/logo.png";
import Row from "../../../components/Row";
import { colors } from "../../../utils/constants";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LanguageIcon from "@mui/icons-material/Language";
import { landingTokens } from "../theme";

interface ContactProps {
  isMobile: boolean;
}

const contactItems = [
  { icon: <PhoneIcon fontSize="small" />, label: "+55 48 991929692" },
  { icon: <EmailIcon fontSize="small" />, label: "qazando@gmail.com" },
  { icon: <LanguageIcon fontSize="small" />, label: "qazando.com.br" },
];

function Contact({ isMobile }: ContactProps) {
  const styles = {
    contactContainer: {
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      flexDirection: "column" as const,
      gap: 3,
      textAlign: "center" as const,
      background: landingTokens.gradient,
      padding: isMobile ? 4 : 12,
      height: isMobile ? "auto" : 50,
    },
    logo: {
      width: isMobile ? 150 : 255,
      objectFit: "contain" as const,
    },
    contactContent: {
      flexDirection: "column" as const,
      display: "flex",
      width: isMobile ? "100%" : "50%",
      gap: 2,
      textAlign: "left" as const,
    },
    contactDescription: {
      textAlign: "left" as const,
      color: colors.white,
      width: isMobile ? "100%" : "40%",
      fontSize: 16,
    },
    contactInfoContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: isMobile ? "start" : "center",
      gap: isMobile ? "12px" : "60px",
      flexDirection: isMobile ? ("column" as const) : ("row" as const),
      marginTop: isMobile ? "24px" : 0,
    },
    contactInfo: {
      color: colors.white,
      fontSize: 16,
      fontWeight: 600,
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
  };

  return (
    <Box sx={styles.contactContainer}>
      <Row space style={{ flexDirection: isMobile ? "column" : "row" }}>
        <Box sx={styles.contactContent}>
          <img src={logo} style={styles.logo} alt="Logo" />
          <span style={styles.contactDescription}>
            Venha falar com a gente, e em poucos minutos criamos seu evento!
          </span>
        </Box>
        <Box sx={styles.contactInfoContainer}>
          {contactItems.map((item) => (
            <Box component="span" key={item.label} sx={styles.contactInfo}>
              {item.icon} {item.label}
            </Box>
          ))}
        </Box>
      </Row>
    </Box>
  );
}

export default Contact;
